import styled from 'styled-components';

export const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap:35px;
    padding:15px;

    @media screen and (max-width: 1200px){
        grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 1000px){
        grid-template-columns: 1fr 1fr 1fr;
    }

    @media screen and (max-width: 750px){
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
    }

    @media screen and (max-width: 480px){
        grid-template-columns: 1fr;

    }
`;

export const GradientFull = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #f00;
    z-index: 111;
    animation-duration: 0.3s;
    animation-timing-function: ease-out;
  
    &:hover {
      cursor: pointer;
    }
`;

export const Container = styled.div`
    border-radius: 40px;
    transition: all 0.2s ease-in-out;

    &:hover{
      box-shadow:0 0px 10px rgba(92, 95, 114, 0.466);
      transition: all 0.2s ease-in-out;
      -webkit-transform: translateY(-5px); 
      -moz-transform: translateY(-5px); 
      -ms-transform: translateY(-5px); 
      -o-transform: translateY(-5px);
      transform: translateY(-5px); 
      }
`;

export const Box = styled.div`
    background:white;
    border-radius: 10px;
    display:flex;
    flex-direction: column;
`;

export const GradientScreen = styled.div`
    height:200px;
    width:100%;
    border-radius: 10px 10px 0 0;
    cursor: pointer;
`;

export const GradientInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding:10px;
`;
  
export const GradientTags = styled.div`
      display: flex;
      flex-direction: row;
      align-items:center;
`;

export const ColorCircle = styled.div`
    width:20px;
    height:20px;
    border-radius:100%;
    margin-right:5px;
`;

export const CircleMain = styled.div`
    cursor:pointer;
`;
export const GradientCopy = styled.div`

`;

export const Tag = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;


export const Button = styled.button`
      background: none;
      border: 0;
      outline: none;
      cursor: pointer;
      color: rgb(48, 48, 48);
    
    &:hover{
      color:rgb(18, 91, 151);
    }
`;

export const Popover = styled.div`
    display:block;
    position: absolute;
    transform: translateY(-30px);
    background-color: white;
    padding: 2px 5px;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.301);
    color: black;
    font-family:'Open Sans';
    font-weight:600;

  &::after{
    content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: -1px;
  right: auto;
  top: 25px;
  bottom: auto;
  border: 10px solid;
  border-radius: 2px;
  border-color: rgb(255, 255, 255) transparent transparent transparent;
  }

`;

export const PopoverNone = styled.div`
    display:none;
`;




